var map = {
	"./opublic.consent.frontend/en.json": 974,
	"./opublic.consent.frontend/fr-CA.json": 172,
	"./opublic.consent.frontend/fr.json": 781,
	"./opublic.consent.frontend/nl.json": 103,
	"./opublic.documents.frontend/en.json": 834,
	"./opublic.documents.frontend/fr.json": 921,
	"./opublic.documents.frontend/nl.json": 755,
	"./opublic.donationForm.frontend/en.json": 456,
	"./opublic.donationForm.frontend/fr.json": 115,
	"./opublic.donationForm.frontend/nl.json": 329,
	"./opublic.shell.frontend/en.json": 593,
	"./opublic.shell.frontend/fr-CA.json": 812,
	"./opublic.shell.frontend/fr.json": 373,
	"./opublic.shell.frontend/nl.json": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;